<!-- src/components/InfoCard.svelte -->
<script>
  export let imageSrc = "";
  export let title = "";
  export let description = "";
  export let alt = "Card image";

  // Emitted when card is clicked → parent opens popup
  export let onClick;
</script>

<div
  class="group block bg-blue-50 rounded-xl shadow-md overflow-hidden cursor-pointer max-w-3xl mx-auto min-w-[320px]"
  on:click={onClick}
  on:keydown={(e) => e.key === "Enter" && onClick?.()}
  tabindex="0"
  role="button"
>
  <div
    class="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-4 p-4 md:p-0"
  >
    {#if imageSrc}
      <div class="flex-shrink-0 self-center md:self-start">
        <img
          src={imageSrc}
          {alt}
          class="w-[190px] h-[190px] object-cover rounded-lg shadow-sm mx-auto md:mx-0"
          width="190"
          height="190"
          loading="lazy"
        />
      </div>
    {/if}

    <!-- Text content – consistent 16px right spacing -->
    <div
      class="flex-1 py-4 md:py-6 pr-4 md:pr-4 lg:pr-4 flex flex-col justify-center"
    >
      {#if title}
        <h3
          class="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-3 group-hover:text-blue-600"
        >
          {title}
        </h3>
      {/if}

      {#if description}
        <p
          class="text-gray-900 text-base md:text-lg leading-relaxed group-hover:text-blue-600"
        >
          {description}
        </p>
      {/if}

      <slot name="extra" />
    </div>
  </div>
</div>
